"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  var params = new URL(window.location.href).searchParams;
  var value = params.get(name);
  if (!value) return;
  var decoded = decodeURIComponent(value);
  return decoded;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/helpers/getQueryParam.js
// module id = 698
// module chunks = 83